import { useContext } from "react";
import PrimaryButton from "../../../helperComponents/PrimaryButton";
import Context from "../../../../Context";
import { FaDonate } from "react-icons/fa";
import DonationInfo from "./DonationInfo";

export default function DonateButton({ item }) {
  const { setForm } = useContext(Context);

  if (item.accountType == "COMPANY") return null;

  return (
    <PrimaryButton
      style={{ flexDirection: "row", minWidth: "55px" }}
      icon={<FaDonate />}
      onClick={openUI}
    >
      {/* Donate */}
    </PrimaryButton>
  );

  function openUI() {
    setForm({
      title: "Donation Info",
      component: <DonationInfo item={item} />,
    });
  }
}
